import { useParams } from 'react-router';
import ArticleDetail from '@components/pages/ArticleDetail';
import { ARTICLES, getArticle } from '@/data/resources';

export default function BlogArticle() {
    const { slug } = useParams();
    const article = getArticle(slug);

    return (
        <ArticleDetail
            item={article}
            related={ARTICLES.filter((a) => a.slug !== slug).slice(0, 4)}
            basePath="/resources/blog"
            backLabel="Back to Blog"
            relatedLabel="Related Articles"
        />
    );
}
